var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderDiscord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.82864 40.3733H30.5205L31.6665 40C34.0395 43.41 39.8196 45.7143 39.8196 45.7143L40.4165 4.58333C40.294 2.03476 37.6214 0 35.0485 0L4.83765 0.00571429C2.26648 0.00571429 -0.833496 2.03476 -0.833496 4.58333L0.179993 35.6571C0.179993 38.3448 2.26287 40.3733 4.82864 40.3733ZM23.834 10.8248L23.7746 10.8476L23.7962 10.8248H23.834ZM10.0845 13.2419C13.3872 10.701 16.4485 10.8229 16.4485 10.8229L16.6953 11.08C12.6539 12.099 10.8214 14.0076 10.8214 14.0076C11.0088 13.9657 19.1692 8.98857 29.0575 14.1333C29.0575 14.1333 27.2214 12.3486 23.4286 11.2057L23.7638 10.8571C24.2881 10.859 27.0629 10.9619 30.0322 13.2571C30.0322 13.2571 33.3548 19.2571 33.3548 26.6286C33.2449 26.4876 31.2935 29.8019 26.2719 29.9162C26.2719 29.9162 25.4214 28.899 24.816 28.0114C27.753 27.12 28.8521 25.3371 28.8521 25.3371C23.1349 29.1429 18.1241 28.5486 12.1295 25.9771C12.0737 25.9771 12.0485 25.9505 12.0196 25.92V25.9086C11.9908 25.88 11.9656 25.8514 11.9097 25.8514H11.8016C11.434 25.5962 11.189 25.4705 11.189 25.4705C11.189 25.4705 12.2863 27.2533 15.1061 28.1448C14.3656 29.0381 13.6322 30.0533 13.6322 30.0533C8.61242 29.9276 6.78179 26.6133 6.78179 26.6133C6.78179 19.2305 10.0845 13.2419 10.0845 13.2419Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1583 24.3257C25.4394 24.3257 26.4826 23.1828 26.4826 21.7733C26.4826 20.3733 25.4448 19.2305 24.1583 19.2305V19.2362C22.8826 19.2362 21.8376 20.3752 21.834 21.7848C21.834 23.1828 22.8772 24.3257 24.1583 24.3257Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8375 24.3257C17.1186 24.3257 18.1618 23.1828 18.1618 21.7733C18.1618 20.3733 17.1258 19.2305 15.8447 19.2305L15.8375 19.2362C14.5564 19.2362 13.5132 20.3752 13.5132 21.7848C13.5132 23.1828 14.5564 24.3257 15.8375 24.3257Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderDiscord);
export default __webpack_public_path__ + "static/media/header-discord.c92293615884b2fae4ab1cce02ad10cc.svg";
export { ForwardRef as ReactComponent };